"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = void 0;
exports.isNumber = (value) => typeof value === "number";
//# sourceMappingURL=is-number.js.map